import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/sftp/explorer")({
    beforeLoad: () => {
        throw redirect({ to: "/developer/sftp/organisations", replace: true });
    },
});
